import { Zone } from "@fairfleet/geotab";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import React from "react";

const ZoneCell = (params: GridRenderCellParams) => {
  const zones: Zone[] = params.row.allZones ?? [];
  const displayedZones = zones.filter(zone => zone?.displayed);
  if (zones?.length > 0) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          height: "100%",
          overflowX: "auto",
          overflowY: "hidden",
          whiteSpace: "nowrap",
          gap: 1,
          paddingY: 0.5,
          paddingX: 0.5,
        }}
      >
        {displayedZones.map(zone => {
          const bgColor = zone.fillColor
            ? `rgba(${zone.fillColor.r}, ${zone.fillColor.g}, ${zone.fillColor.b}, ${200 / 255})`
            : "#ccc";

          return (
            <Chip
              key={zone.id}
              label={zone.name}
              size="small"
              sx={{
                backgroundColor: bgColor,
                color: "#fff",
                fontWeight: 500,
              }}
            />
          );
        })}
      </Box>
    );
  } else {
    return <></>;
  }
};

export default ZoneCell;
